/**
 * 셀프호스팅 Pretendard JP 폰트 에셋 경로 (public/fonts)
 * /fonts/* 는 immutable 1년 캐시이므로 폰트 교체 시 반드시 버전 디렉토리를 올릴 것
 */
const JA_FONT_BASE_URL = '/fonts/pretendard-jp/v1.3.9';

export const JA_FONT_CSS_URL = `${JA_FONT_BASE_URL}/pretendard-jp-variable.css`;

// 히라가나/가타카나/일본어 구두점을 담은 서브셋 — ja 페이지라면 사실상 항상 필요
export const JA_CRITICAL_FONT_SUBSET_URLS = [
  53, 60, 64, 76, 78, 105, 114, 115, 118,
].map(n => `${JA_FONT_BASE_URL}/woff2/PretendardJPVariable.subset.${n}.woff2`);
